export const DISTRIBUTION_SETUP_REQUEST = 'DISTRIBUTION_SETUP_REQUEST';
export const DISTRIBUTION_SETUP_SUCCESS = 'DISTRIBUTION_SETUP_SUCCESS';
export const DISTRIBUTION_SETUP_FAIL = 'DISTRIBUTION_SETUP_FAIL';

export const DISTRIBUTION_MY_RECORDS_REQUEST = 'DISTRIBUTION_MY_RECORDS_REQUEST';
export const DISTRIBUTION_MY_RECORDS_SUCCESS = 'DISTRIBUTION_MY_RECORDS_SUCCESS';
export const DISTRIBUTION_MY_RECORDS_FAIL = 'DISTRIBUTION_MY_RECORDS_FAIL';

export const DISTRIBUTION_SUBMIT_REQUEST = 'DISTRIBUTION_SUBMIT_REQUEST';
export const DISTRIBUTION_SUBMIT_SUCCESS = 'DISTRIBUTION_SUBMIT_SUCCESS';
export const DISTRIBUTION_SUBMIT_FAIL = 'DISTRIBUTION_SUBMIT_FAIL';
export const DISTRIBUTION_SUBMIT_RESET = 'DISTRIBUTION_SUBMIT_RESET';

export const DISTRIBUTION_BULK_UPDATE_REQUEST = 'DISTRIBUTION_BULK_UPDATE_REQUEST';
export const DISTRIBUTION_BULK_UPDATE_SUCCESS = 'DISTRIBUTION_BULK_UPDATE_SUCCESS';
export const DISTRIBUTION_BULK_UPDATE_FAIL = 'DISTRIBUTION_BULK_UPDATE_FAIL';
export const DISTRIBUTION_BULK_UPDATE_RESET = 'DISTRIBUTION_BULK_UPDATE_RESET';
